export default __webpack_public_path__ + "static/media/Brockhampton_Sugar_1M.9e71e697.mp4";